import React from 'react';
import { Inbox } from 'lucide-react';
import { Button } from '../../ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';
import { MessagesInbox } from './MessagesInbox';
import { useMessagesContext } from '../../../context/MessagesContext';
import { cn } from '../../../lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../ui/tooltip';
import { useModalState } from '../../../hooks/useModalState';

export function MessagesIcon() {
  // Only need badge data, not full list
  const { unreadCount } = useMessagesContext();
  const { isOpen, setOpen } = useModalState();

  return (
    <Tooltip>
      <Popover open={isOpen} onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          <PopoverTrigger asChild>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className={cn(
                'relative rounded-full text-muted-foreground hover:text-foreground',
                isOpen && 'bg-primary/10 text-primary'
              )}
              aria-label="Open messages inbox"
            >
              <Inbox className="h-5 w-5" />
              {unreadCount > 0 && (
                <span className="absolute right-1 top-1 inline-flex h-2 w-2 rounded-full bg-destructive" />
              )}
            </Button>
          </PopoverTrigger>
        </TooltipTrigger>
        <PopoverContent className="w-96 max-w-[calc(100vw-1rem)] max-h-[calc(100dvh-5rem)] overflow-y-auto p-0" align="end">
          <MessagesInbox />
        </PopoverContent>
      </Popover>
      <TooltipContent side="bottom" align="center">
        Messages
      </TooltipContent>
    </Tooltip>
  );
}


